import { useForm } from "react-hook-form";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
export default function OtpValidation({ setSelect, oldPhone ,select}) {
  const {
    register,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code0: "",
      code1: "",
      code2: "",
      code3: "",
    },
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const verifyOTP = async (otp) => {
    const { status, data } = await apiPost(
      apiPath.verifyOtpNew,
      select?.type === "phone" && select?.statusPhone
        ? {
            phone_number: profileData?.phone,
            new_phone_number: oldPhone,
            otp: otp,
          }
        : {
            phone_number: profileData?.phone,
            otp: otp,
          },
    );

    if (data.success) {
      toast.success("OTP Verified");
      setSelect({});
      getProfileData();
    } else {
      reset({
        code0: "",
        code1: "",
        code2: "",
        code3: "",
      });
       toast.error(data.message);
    }
    // try {
    //   // API CALL
    //   const response = await fetch("/verify-otp", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({ otp }),
    //   });

    //   const data = await response.json();

    //   // FAILED RESPONSE
    //   if (!response.ok || !data.success) {
    //     reset({
    //       code0: "",
    //       code1: "",
    //       code2: "",
    //       code3: "",
    //     });

    //     document.getElementById("code-0")?.focus();
    //     return;
    //   }

    //   console.log("OTP Verified");
    // } catch (error) {
    //   reset({
    //     code0: "",
    //     code1: "",
    //     code2: "",
    //     code3: "",
    //   });

    document.getElementById("code-0")?.focus();
    // }
  };

  const handleInput = async (e, index) => {
    let value = e.target.value.replace(/\D/g, "");

    // allow only single digit
    value = value.slice(0, 1);

    setValue(`code${index}`, value);

    // move next input
    if (value && index < 3) {
      document.getElementById(`code-${index + 1}`)?.focus();
    }

    // AUTO SUBMIT AFTER LAST DIGIT
    if (index === 3 && value) {
      const values = getValues();

      const otp = values.code0 + values.code1 + values.code2 + value;

      // validate 4 digits
      if (/^\d{4}$/.test(otp)) {
        verifyOTP(otp);
      }
    }
  };

  const handleKeyDown = (e, index) => {
    // move previous on backspace
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      document.getElementById(`code-${index - 1}`)?.focus();
    }
  };

  return (
    <form
      noValidate
      name="one-time-code"
      className="verification-code ng-untouched ng-pristine ng-valid"
    >
      <fieldset>
        <label htmlFor="code-1" className="label">
          Number 1
        </label>

        <label htmlFor="code-2" className="label">
          Number 2
        </label>

        <label htmlFor="code-3" className="label">
          Number 3
        </label>

        <label htmlFor="code-4" className="label">
          Number 4
        </label>

        <div id="verification-input" className="verification-input">
          <input
            type="number"
            pattern="[0-9]*"
            min={0}
            max={9}
            maxLength={1}
            defaultValue=""
            inputMode="numeric"
            id="code-0"
            className="ng-star-inserted"
            {...register("code0", {
              required: true,
              pattern: /^[0-9]$/,
            })}
            onInput={(e) => handleInput(e, 0)}
            onKeyDown={(e) => handleKeyDown(e, 0)}
          />

          <input
            type="number"
            pattern="[0-9]*"
            min={0}
            max={9}
            maxLength={1}
            defaultValue=""
            inputMode="numeric"
            id="code-1"
            className="ng-star-inserted"
            {...register("code1", {
              required: true,
              pattern: /^[0-9]$/,
            })}
            onInput={(e) => handleInput(e, 1)}
            onKeyDown={(e) => handleKeyDown(e, 1)}
          />

          <input
            type="number"
            pattern="[0-9]*"
            min={0}
            max={9}
            maxLength={1}
            defaultValue=""
            inputMode="numeric"
            id="code-2"
            className="ng-star-inserted"
            {...register("code2", {
              required: true,
              pattern: /^[0-9]$/,
            })}
            onInput={(e) => handleInput(e, 2)}
            onKeyDown={(e) => handleKeyDown(e, 2)}
          />

          <input
            type="number"
            pattern="[0-9]*"
            min={0}
            max={9}
            maxLength={1}
            defaultValue=""
            inputMode="numeric"
            id="code-3"
            className="ng-star-inserted"
            {...register("code3", {
              required: true,
              pattern: /^[0-9]$/,
            })}
            onInput={(e) => handleInput(e, 3)}
            onKeyDown={(e) => handleKeyDown(e, 3)}
          />
        </div>

        {(errors.code0 || errors.code1 || errors.code2 || errors.code3) && (
          <p className="error">Please enter valid 4 digit OTP</p>
        )}
      </fieldset>
    </form>
  );
}
